import { createAction, props } from '@ngrx/store';

import {
  CancelStoreStockRecall,
  CreateStoreStockRecall,
  CreateStoreStockRecallErrorItem
} from '../../model/create-store-stock-recall.model';

export const createStoreStockRecallRequest = createAction(
  '[CreateStoreStockRecall] Create Store Stock Recall Request',
  props<{ payload: CreateStoreStockRecall }>()
);

export const cancelStoreStockRecallRequest = createAction(
  '[CreateStoreStockRecall] Cancel Store Stock Recall Request',
  props<{ payload: CancelStoreStockRecall }>()
);

export const createStoreStockRecallPackingRequest = createAction(
  '[CreateStoreStockRecall] Create Store Stock Recall Packing Request',
  props<{ payload: CreateStoreStockRecall }>()
);

export const errorCreateStoreStockRecallResponse = createAction(
  '[CreateStoreStockRecall] Error Create Store Stock Recall Response',
  props<{ items: CreateStoreStockRecallErrorItem[] }>()
);

export const draftStoreStockRecallPackingRequest = createAction(
  '[CreateStoreStockRecall] Draft Store Stock Recall Packing Request',
  props<{ payload: CreateStoreStockRecall }>()
);

export const deleteDraftStoreStockRecallPackingRequest = createAction(
  '[CreateStoreStockRecall] Delete Draft Stock Recall Packing Request',
  props<{ id: string }>()
);
